import { jwtDecode } from 'jwt-decode';
import { makeAutoObservable } from 'mobx';
import { getOneUser } from '../API/userApi';
import { getOneEmployee } from '../API/employeeApi';

export default class UserStore {
    constructor() {
        // this._isAuth = true;
        this._isAuth = false;
        this._isLoading = true;
        // this._user = {
        //     id: 2,
        //     last_name: 'no data',
        //     first_name: 'no data',
        //     patronymic: 'no data',
        //     username: 'no data',
        //     employee: { post: 'no data' },
        // };
        this._user = null;
        this._employee = null;
        makeAutoObservable(this);
        this.checkAuth();
    }

    setIsAuth(boollean) {
        this._isAuth = boollean;
    }

    setUser(user) {
        this._user = user;
    }
    setEmployee(employee) {
        this._employee = employee;
    }

    setIsLoading(boollean) {
        this._isLoading = boollean;
    }

    get isAuth() {
        return this._isAuth;
    }

    get user() {
        return this._user;
    }
    get employee() {
        return this._employee;
    }

    get isLoading() {
        return this._isLoading;
    }

    async checkAuth() {
        try {
            const token = localStorage.getItem('access_token');
            if (token) {
                const decoded = jwtDecode(token);
                const userData = await getOneUser(decoded.user_id);
                const employeeData = await getOneEmployee(decoded.user_id);
                this.setUser(userData);
                this.setEmployee(employeeData);
                this.setIsAuth(true);
            }
        } catch (error) {
            console.log('Auth check failed:', error);
            localStorage.removeItem('access_token');
        } finally {
            this.setIsLoading(false);
        }
    }
}

